<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant';
import miscMaskDark from '@images/pages/misc-mask-dark.png';
import miscMaskLight from '@images/pages/misc-mask-light.png';

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

definePage({
  alias: '/pages/misc/not-found/:error(.*)',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader status-code="404" title="Page Not Found ⚠️"
      description="We couldn't find the page you are looking for." />

    <VBtn to="/" class="mb-12">
      Back to Home
    </VBtn>

    <!-- Image Section -->
    <div class="misc-avatar w-100 text-center">
      <VImg :src="authThemeMask" alt="Decorative Mask Image" :max-width="200" class="mx-auto" />
    </div>

    <VImg :src="authThemeMask" class="misc-footer-img d-none d-md-block" />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
